import { Breadcrumbs, Typography, Box } from "@mui/material";
import { breadcrumbActiveStyle, breadcrumbInactiveStyle } from "./CouponStyles";

interface BreadcrumbSectionProps {
  paymentActive?: boolean
}

export const BreadcrumbSection: React.FC<BreadcrumbSectionProps> = ({ paymentActive }) => (
  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 1 }}>
    <Breadcrumbs 
      aria-label="breadcrumb" 
      separator=">" 
      sx={{   
        '& .MuiBreadcrumbs-separator': { 
          color: '#01010199',
          fontSize: '12px'
        },
      }}
    >
      <Typography sx={paymentActive ? breadcrumbInactiveStyle : breadcrumbActiveStyle}>Entrega</Typography>
      <Typography sx={paymentActive ? breadcrumbActiveStyle : breadcrumbInactiveStyle}>Pago</Typography>
    </Breadcrumbs>
  </Box>
);














